import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { organizationsSelector } from "../../../selectors";
import { getOrganizations } from "../../../actions";

import { userManagerFactory } from "../../../services/oidc/utils/userManager";
import { PageTitle } from "../../../components/common";
import LoginOrganizationPage from "./LoginOrganizationPage";

const LoginOidcPage = () => {
  const dispatch = useDispatch();

  const organizations = useSelector(organizationsSelector);

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    setIsLoading(true);
    const userManager = userManagerFactory();
    userManager.signinRedirect();
  };

  useEffect(() => {
    dispatch(getOrganizations());
  }, []);

  return (
    <React.Fragment>
      <PageTitle title="login" className="bg-white page-title-login" />
      <LoginOrganizationPage
        organizations={organizations}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </React.Fragment>
  );
};

export default LoginOidcPage;



// WEBPACK FOOTER //
// ./src/features/login/pages/LoginOidcPage.jsx